// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"332":"detail","962":"home"}[chunkId] + "." + {"332":"248f7e9d","962":"df4b3166"}[chunkId] + ".js";
};